export default "__VITE_ASSET__DRHm2d4q__"